import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
//import { render } from "react-dom";
import { Helmet } from "react-helmet";
import Topbar from "./scenes/global/Topbar.jsx";
import SidebarZ from "./scenes/global/Sidebar.jsx";

import LandingPage from "./components/LandingPage.jsx";
//import SidebarZ from "./scenes/global/SidebarX.jsx";
import Dashboard from "./scenes/dashboard/index.jsx";
import Team from "./scenes/team/index.jsx";
import Invoices from "./scenes/invoices/index.jsx";
import Contacts from "./scenes/contacts/index.jsx";
import Bar from "./scenes/bar/index.jsx";
import Form from "./scenes/form/index.jsx";
//import SchoolAdmins from "./scenes/form/SchoolAdmins.jsx";
import SchoolAdmins from "./scenes/school_admins/index.jsx";

import ParentExamsResults from './scenes/form/ParentExamsResults.jsx'

import DistrictAdmins from "./scenes/district_admins/index.jsx";


import SchoolStudents from "./scenes/school_students/index.jsx";
import SchoolClass from "./scenes/form/SchoolClass.jsx";

import SchoolSubClass from "./scenes/form/SchoolSubClass.jsx";

//SchoolAdmins
import TestForm from "./scenes/form/TestForm.jsx";
import CMMForm from "./scenes/form/CMMForm.jsx";

import School from "./scenes/school/index.jsx";
//import PatientRegistrationForm from "./scenes/form/PatientRegistrationForm.jsx"; teamOnWebsite

import PRFHooks from "./scenes/form/PRFHooks.jsx";
import ProjectCategoryContainer from "./scenes/form/ProjectCategoryContainer.jsx";
import FormProjects from "./scenes/form/FormProjects.jsx";
import FormNewWebTeam from "./scenes/form/FormNewWebTeam.jsx";
///    FormCompanyContainer
import FormCompanyContainer from "./scenes/form/FormCompanyContainer.jsx";

import FormUsersCont from "./scenes/form/FormUsersCont.jsx";
//import RFHFormSubmit from "./scenes/form/RFHFormSubmit.jsx";

//import PRFDetails from "./scenes/form/PRFDetails.jsx";

import Line from "./scenes/line/index.jsx";
import Pie from "./scenes/pie/index.jsx";
import FAQ from "./scenes/faq/index.jsx";
import Geography from "./scenes/geography/index.jsx";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar.jsx";
import Login from "./scenes/form/Login.jsx";
import StudentStream from "./scenes/form/StudentStream.jsx";
import SchoolExams from "./scenes/form/SchoolExams.jsx";

//
import ExamSubjects from "./scenes/exam_subjects/index.jsx";

import StudentExamScore from "./scenes/form/StudentExamScore.jsx";

import Announcements from "./scenes/form/Announcements.jsx";

import SchoolTeachers from "./scenes/school_teachers/index.jsx";

import TransferStudents from "./scenes/form/TransferStudents.jsx";

import SubClassExamsResults from "./scenes/form/SubClassExamsResults.jsx";

//DistrictExamsData
import DistrictExamsData from "./scenes/form/DistrictExamsData.jsx";

//import ParentExamsResults from "./scenes/form/ParentExamsResults.jsx";
//import Contact from "./pages/Contact";   path('systemUsers', index),
//import NoPage from "./pages/NoPage";
import { useSearchParams } from 'react-router-dom'; 

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);

  const [showContainer, setShowContainer]=useState(false);

  const [showParentReport, setShowParentReport]=useState(false);
  
  //const [searchParams, setSearchParams]=useSearchParams();
  //const stestr = searchParams.get('ste');

  const [loggedInUserId, setLoggedInUserId]=useState('');
  const [loggedInUserName, setLoggedInUserName]=useState('');
  const [loggedInUserCategory, setLoggedInUserCategory]=useState('');
  const [userRolesList, setUserRolesList]=useState([]);
  const [loginCategory, setLoginCategory]=useState('');
  const [loginDetailsForm, setLoginDetailsForm]=useState({});
  const [schoolDetails, setSchoolDetails]=useState({})
  const [schoolName, setSchoolName]=useState('')
  const [schoolId, setSchoolId]=useState('')
  
  const handleLogout=(data)=>{
    setShowContainer(data)
  }

  const handleLogin=(data, usersId, userName, loginCategoryName, rolesList, loginDetailsForm, schoolDetails, loginDetails)=>{
    setShowContainer(data)
    setLoggedInUserId(loginDetails['usersId'])
    setLoggedInUserName(loginDetails['fullName'])
    console.log("ABFG name=" + userName)
    setLoggedInUserCategory(loginDetails['loginCategory'])
    console.log("ABFG loginCategoryName=" + loginDetails['loginCategory'])
    console.log("WED =" + loginDetails['fullName'])
    //usersId, fullName, loginCategoryName
    setUserRolesList(rolesList)
    setLoginCategory(loginDetails['loginCategory'])
    setLoginDetailsForm(loginDetailsForm)
    setSchoolName(schoolDetails['schoolName'])
    setSchoolId(schoolDetails['schoolId'])
    console.log("WED 11 =" + schoolDetails['schoolId'])
   
 }


return (
  <BrowserRouter>
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="App">
        
        { showContainer?
        (
          <SidebarZ isSidebar={isSidebar} 
          loginCategory={loginCategory}
          userId={loggedInUserId} 
          userName={loggedInUserName}
          />
        ):('')
       }
          <main className="content">
          { showContainer?
        (

          <>
            <Topbar setIsSidebar={setIsSidebar} 
            loginCategory={loginCategory}
            userId={loggedInUserId} 
            userName={loggedInUserName}
            schoolName={schoolName}
            schoolId={schoolId}
            sendDataToParent={handleLogout}
            />
    
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/schoolAdmins" element={<SchoolAdmins />} /> 
           
          <Route path="/districtAdmins" element={<DistrictAdmins />} /> 

          <Route path="/schoolTeachers" 
          element={<SchoolTeachers schoolIdGlobal={schoolId} />} /> 


          <Route path="/LandingPage" 
          element={<LandingPage />} /> 

          <Route path="/SchoolStudents" 
          element={<SchoolStudents schoolIdGlobal={schoolId} schoolName={schoolName} userName={loggedInUserName} />} 
          />
          <Route path="/SchoolClass" 
          element={<SchoolClass schoolIdGlobal={schoolId} />} 
          />


          <Route path="/SchoolSubClass" 
          element={<SchoolSubClass schoolIdGlobal={schoolId} />} />
          <Route path="/StudentStream" element={<StudentStream />} />
          
          <Route path="/TransferStudents" 
          element={<TransferStudents schoolIdGlobal={schoolId} />} />
          
      

          <Route path="/ParentExamsResults" 
          element={<ParentExamsResults schoolIdGlobal={schoolId} />} />
          

          <Route path="/SubClassExamsResults" 
          element={<SubClassExamsResults schoolIdGlobal={schoolId} />} />
          
          <Route path="/DistrictExamsData" 
          element={<DistrictExamsData schoolIdGlobal={schoolId} />} />
          

          <Route path="/ParentReports" 
          element={<ParentExamsResults schoolIdGlobal={schoolId} />} />

          
          
          <Route path="/SchoolExams" 
          element={<SchoolExams schoolIdGlobal={schoolId} />} />

          <Route path="/ExamSubjects" 
          element={<ExamSubjects schoolIdGlobal={schoolId} usersId={loggedInUserId}   />} 
          />

          <Route path="/StudentExamScore" 
          element={<StudentExamScore schoolIdGlobal={schoolId} usersId={loggedInUserId} />} 
          />


          <Route path="/school" element={<School />} />
          <Route path="/team" element={<Team />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/contacts" element={<Contacts />} />

          {/***/}
          <Route path="/patientRegistration" element={<PRFHooks />} /> 
          {/***/}
          <Route path="/patientRegistrationRecords" element={<Contacts />} /> 
          {/**/}
           <Route path="/primaryProjectCategoryList" element={<ProjectCategoryContainer />} /> 
           {/* **/}
           <Route path="/primaryProjects" element={<FormProjects />} />
           <Route path="/teamOnWebsite" element={<FormNewWebTeam />} />
           <Route path="/systemUsers" element={<FormUsersCont />} />
           <Route path="/company" element={<FormCompanyContainer />} />
          {/** <Route path="/patientRegistration" element={<Antd />} /> FormUsersCont **/}
          {/** <Route path="/patientRegistration" element={<Antd />} /> **/}
          <Route path="/primaryProjectCategoryListT" element={<CMMForm />} /> 
          
          <Route path="/testform" element={<TestForm />} />
          
          <Route path="/Announcements" element={<Announcements />} />
          
          <Route path="/invoices" element={<Invoices />} />
         
          <Route path="/form" element={<Form />} />
           
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/bar" element={<Bar />} />
          <Route path="/pie" element={<Pie />} />
          <Route path="/line" element={<Line />} />
          <Route path="/geography" element={<Geography />} />
          </Routes>
      
      </>
      )
      :(
        <>
        {/*** *
      <div sx={{ width: "100%", }}>
       <LandingPage sendDataToParent={handleLogin} />
       </div>
      ***/}
      
        <Helmet>
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
          <link href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap" rel="stylesheet" />
        </Helmet>
        <LandingPage sendDataToParent={handleLogin} />
      </>
     )
     }
      

      {/*** *
      { showParentReport?
      (
        <>
        <Routes>
        <Route path="/" element={<ParentExamsResults />} />
        </Routes>
        </>
      ):''
      }
      ***/}

    </main>
         
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  </BrowserRouter>
  );
}

//const appDiv=document.getElementById("app");old
//render(<App />, appDiv)old
export default App;